/**
 * Jungle Powders: Fast Bundle chip trigger
 * Opens the Fast Bundle Mix & Match modal from any [data-jp-fastbundle-trigger] element.
 * Finds Fast Bundle's "View offer details" button without relying on its
 * generated class hash (that hash changes when Fast Bundle updates).
 */
(function () {
  function findOfferButton() {
    var widgets = document.querySelectorAll('[id^="rbr-bundle-"]');
    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i];
      var btn = w.querySelector('[class*="button_container_"][class*="button_primary_"]') ||
                w.querySelector('[class*="button_container_"]');
      if (btn) return btn;

      var els = w.querySelectorAll('button, a, [role="button"], div, span');
      for (var j = els.length - 1; j >= 0; j--) {
        var t = (els[j].textContent || '').trim().toLowerCase();
        if (t === 'view offer details') return els[j];
      }
    }
    return null;
  }

  function clickWithRetry(maxMs) {
    var start = Date.now();
    return new Promise(function (resolve) {
      (function tick() {
        var btn = findOfferButton();
        if (btn) { btn.click(); return resolve(true); }
        if (Date.now() - start >= maxMs) return resolve(false);
        setTimeout(tick, 200);
      })();
    });
  }

  function bind() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-jp-fastbundle-trigger]');
      if (!trigger) return;
      e.preventDefault();
      clickWithRetry(3000).then(function (ok) {
        if (!ok) console.warn('[JP] Could not find Fast Bundle "View offer details" button.');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();